import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

import { Button } from '@material-ui/core'

import { Permitted } from 'components/Permissions'

const LogButton = props => {
  return (
    <Permitted admin>
      <Button variant="text" color="default" component={Link} {...props}>
        Logs
      </Button>
    </Permitted>
  )
}

export default LogButton

LogButton.propTypes = {
  to: PropTypes.any.isRequired,
}
